import { ContractMessage } from '../../../../../types/ContractMessage';
import { Button } from '../../../../cdl/Button/Button';
import { Modal } from '../../../../cdl/Modal/Modal';
import { Text } from '../../../../cdl/Text/Text';
import { ButtonGroup } from '../../../../common/buttons/ButtonGroup';
import { translate } from '../../../../common/helpers/translate.helper';
import { Characters } from '../../../../common/helpers/unicode.helper';
import { PartlyBoldTranslation } from '../../../../common/PartlyBoldTranslation';
import { Box } from '../../../../common/ui/Box';

interface SetDefaultContractModalProps {
    contract: ContractMessage;
    supplierChange: {
        currentSupplierName: string;
        newSupplierName: string;
    } | null;
    isSubmitting?: boolean;
    onConfirm: () => void;
    onDismiss: () => void;
}

export const SetDefaultContractModal = ({
    contract,
    supplierChange,
    isSubmitting = false,
    onConfirm,
    onDismiss,
}: SetDefaultContractModalProps) => {
    return (
        <Modal isOpen onDismiss={onDismiss} scrollable={false} dismissible={false}>
            <Box padding={24} display="grid" rowGap={16}>
                <Text variant="title">{translate('vessel.contracts.setDefaultModal.title')}</Text>
                <Text variant="body">
                    <PartlyBoldTranslation
                        translation={
                            supplierChange
                                ? translate('vessel.contracts.setDefaultModal.descriptionWithSupplier', {
                                      contractName: contract.name,
                                  })
                                : translate('vessel.contracts.setDefaultModal.description', {
                                      contractName: contract.name,
                                  })
                        }
                    />
                </Text>

                {supplierChange ? (
                    <Box display="flex" alignItems="flex-end" columnGap={16} paddingBottom={16}>
                        <Box display="grid" rowGap={8} flex="1">
                            <Text variant="subtitle2">
                                {translate('vessel.contracts.setDefaultModal.currentDefaultSupplier')}
                            </Text>
                            <Text variant="extraSmall">{supplierChange.currentSupplierName}</Text>
                        </Box>
                        <Text variant="extraSmall">{Characters.RIGHTWARDS_ARROW}</Text>
                        <Box display="grid" rowGap={8} flex="1">
                            <Text variant="subtitle2">
                                {translate('vessel.contracts.setDefaultModal.newDefaultSupplier')}
                            </Text>
                            <Text variant="extraSmall">{supplierChange.newSupplierName}</Text>
                        </Box>
                    </Box>
                ) : null}

                <ButtonGroup justifyContent="flex-end">
                    <Button type="button" onClick={onDismiss} disabled={isSubmitting}>
                        {translate('btn.cancel')}
                    </Button>
                    <Button emphasis="high" type="button" onClick={onConfirm} isLoading={isSubmitting}>
                        {translate('vessel.contracts.actions.setDefaultContract')}
                    </Button>
                </ButtonGroup>
            </Box>
        </Modal>
    );
};
